import './ScreenMessage.css';

export interface Props {
  message: string;
}

export const ScreenMessage: React.FC<Props> = (props) => {
  return (
    <div className="screenmessage-container">
      <span className="screenmessage-text">{props.message}</span>
    </div>
  );
};
